<template>
  <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <div class="user-ideogram" :data-letters="userIdeogramName"></div>
          <span v-if="certificationPending" class="avatar-notification-dot"></span>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="invoice" v-if="hasPerm('contract_manager.service_order.list')">
      <CIcon name="cip-order" size="custom-size"
             :height="16"/>
      <span v-translate>Invoices</span>
    </CDropdownItem>
    <CDropdownItem @click="openCompanyManagement" v-if="hasPerm('menu.certification')">
      <CIcon name="cipBuilding" size="custom-size" :height="16"/>
      <span v-translate translate-context="header.account">Company management</span>
      <CIcon v-if="certificationPending" name="cipInfo" class="ml-2 text-warning">!</CIcon>
    </CDropdownItem>
    <CDropdownItem @click="profile">
      <CIcon name="cip-user" size="custom-size"
             :height="16"/>
      <span v-translate>My profile</span>
    </CDropdownItem>
    <!-- TODO: temporaneamente nascosto
    <CDropdownItem @click="invitations">
      <CIcon name="cip-mail" size="custom-size"
             :height="20"/>
      <span v-translate>My invitations</span>
      <CBadge v-if="pendingInvitationsCount > 0" color="danger" class="ml-2">
        {{ pendingInvitationsCount }}
      </CBadge>
    </CDropdownItem>
    -->
    <CDropdownItem
      v-if="hasPerm('dashboard.impersonate')"
      @click="onRefreshPermissions"
    >
      <CIcon name="cipReload" size="custom-size" :height="16"/>
      <span v-translate>Refresh Permissions</span>
    </CDropdownItem>
    <CDropdownItem @click="onLogout">
      <CIcon name="cip-exit" size="custom-size"
             :height="16"/>
      <translate>Logout</translate>
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'TheHeaderDropdownAccount',
  computed: {
    ...mapGetters('login', ['userIdeogramName', 'userCompactName']),
    ...mapGetters('userStatus', ['certificationPending']),
    // TODO: temporaneamente disabilitato
    // ...mapGetters('invitations', ['pendingCount']),
    // pendingInvitationsCount() {
    //   return this.pendingCount || 0
    // }
  },
  methods: {
    ...mapActions('login', ['logout', 'refreshPermissions']),
    async profile() {
      await this.$router.push({name: 'user'})
    },
    // TODO: temporaneamente disabilitato
    // async invitations() {
    //   await this.$router.push({name: 'invitations.list'})
    // },
    async invoice() {
      await this.$router.push({name: 'serviceOrders.list'})
    },
    async onRefreshPermissions() {
      await this.refreshPermissions()
      window.location.reload()
    },
    openCompanyManagement() {
      this.$emit('open-company-management')
    },
    async onLogout() {
      await this.logout()
      await this.$router.push({name: 'login'})
    }
  }
}
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}

.avatar-notification-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background-color: #F79009;
  border-radius: 50%;
  border: 2px solid #fff;
}

.c-avatar {
  position: relative;
  background-color: #CECCE8;
  color: #fff;
}
</style>
